(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !window.DesignMode) return;
  try {
    
    var live_url = window.location.href;
    var result = live_url.includes('form_type=customer');
    if(result){
        document.querySelector('#emailExists').classList.remove("hidden");
    }
  
  } catch(e) { console.error(e); }
})();
})();
